import {Typography} from 'antd';
import {FilterLayout} from 'components';

const Search = () => {
    return (
        <FilterLayout>
            <section>
                <Typography.Title level={2}>Search</Typography.Title>
            </section>
        </FilterLayout>
    );
};

export default Search;
